module.exports = __webpack_public_path__ + "img/infrastructure-10.9dfdeca2.png";